import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'unico-people-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent {

  constructor(public dialogInfoActions: MatDialogRef<InfoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

}
